import classes from "./CaseStudiesItemsDesktop.module.scss";
import classNames from "classnames";
import { getItemHeight, getItemWidth } from "./helper";
import { CaseStudyResponse } from "../../../data/caseStudies";
import HtmlParser from "../../utilities/HTMLParser";
import { ECommerce, eCommerceHash } from "../ECommerce";
import { VRTechnology, vrTechHas } from "../VRTechnology";
import { MedicalSoftware, medicalSoftwareHash } from "../MedicalSoftware";
import TranslatedLink from "../../utilities/TranslatedLink";
import { useRouter } from "next/router";
import Image from "next/image";
import { Finance, financeHash } from "../Finance";
import { useTranslation } from "react-i18next";

const studyItemsCount = 4;
const itemStyles = [
  {
    background: "#D9D9D9",
    className: classes.finance,
    color: "black",
    left: 0,
    top: 0,
    width: getItemWidth(0, studyItemsCount),
    height: getItemHeight(studyItemsCount),
  },
  {
    background: "#FEDF00",
    className: classes.medical,
    color: "black",
    right: 0,
    top: 0,
    width: getItemWidth(1, studyItemsCount),
    height: getItemHeight(studyItemsCount),
  },
  {
    background: "#239ED4",
    className: classes.eCommerce,
    color: "white",
    left: 0,
    bottom: 0,
    // top: "50%", // in case of 5-6 items
    // transform: "translateY(-50%)", // in case of 5-6 items
    width: getItemWidth(2, studyItemsCount),
    height: getItemHeight(studyItemsCount),
  },
  {
    background: "#5B5A5A",
    className: classes.vrTechnology,
    color: "white",
    right: 0,
    bottom: 0,
    // top: "50%", // in case of 5-6 items
    // transform: "translateY(-50%)", // in case of 5-6 items
    width: getItemWidth(3, studyItemsCount),
    height: getItemHeight(studyItemsCount),
  },
  // this is how 5. item would look like
  // {
  //   background: "#233F82",
  //   color: "white",
  //   right: 0, // only if we have exactly 5 items not more
  //   left: 0,
  //   bottom: 0,
  //   width: getItemWidth(4, studyItemsCount),
  //   height: getItemHeight(studyItemsCount),
  // },
];

type Props = {
  data: CaseStudyResponse;
};

const studiesMapping = [
  eCommerceHash,
  medicalSoftwareHash,
  vrTechHas,
  financeHash,
];

export const CaseStudiesItemsDesktop = ({ data }: Props) => {
  const router = useRouter();
  const { t } = useTranslation(["case-studies"]);
  const selectedItem = router.asPath.split("#")[1];
  const openedItem = studiesMapping.findIndex((item) => item === selectedItem);
  const caseStudies = data?.data;
  return (
    <>
      <div className={classes.container}>
        {caseStudies
          ?.sort((cs, cs2) => cs.id - cs2.id)
          .map(({ attributes, id }, index) => {
            const itemStyle = itemStyles[index];
            return (
              <div
                key={id}
                style={itemStyle}
                onClick={() => {
                  router.push(`#${studiesMapping[index]}`);
                }}
                className={classNames(
                  classes.caseStudiesItem,
                  index % 2 === 0 &&
                    index === caseStudies.length - 1 &&
                    classes.caseStudiesItemFullWidth
                )}
              >
                <div className={classes.contentContainer}>
                  <Image
                    src={attributes.image?.data?.attributes.url}
                    alt={attributes.title}
                    objectFit="cover"
                    layout="responsive"
                    width={500}
                    height={400}
                    className={classes.image}
                    style={{
                      position: "absolute",
                      width: "100%",
                      filter: "grayscale(100%)",
                    }}
                  />
                  <div
                    className={classNames(classes.content, itemStyle.className)}
                  >
                    <h2
                      style={{
                        color: itemStyle.color,
                        background: itemStyle.background,
                        padding: 36,
                      }}
                    >
                      {attributes.title}
                    </h2>
                    <div className={classes.longDescription}>
                      {index === 3 ? (
                        <div className={classes.preparing}>
                          {t("preparation")}
                        </div>
                      ) : (
                        <div>
                          <HtmlParser html={attributes.perex} />
                        </div>
                      )}
                      {index !== 3 && (
                        <div className="mt-4">
                          <TranslatedLink
                            href={`#${studiesMapping[index]}`}
                            className={classes.showMore}
                            style={{ color: itemStyle.color }}
                          >
                            Zobrazit více
                          </TranslatedLink>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>
      {openedItem === 0 && <ECommerce />}
      {openedItem === 1 && <MedicalSoftware />}
      {openedItem === 2 && <VRTechnology />}
      {openedItem === 3 && <Finance />}
    </>
  );
};
